import React, { useContext } from 'react';

import { Button, ButtonTheme } from '@imgly/imgly-website-components';
import classNames from 'classnames';

import { ReactComponent as SearchIcon } from '../../../assets/images/icons/Search.svg';
import { SearchContext } from '../../../context/SearchContext';

import * as classes from './style.module.scss';

interface Props {
  className?: string;
}

export const HeaderSearch: React.FC<Props> = ({ className }) => {
  const { openSearch } = useContext(SearchContext);

  return (
    <Button
      leadingIcon={<SearchIcon />}
      theme={ButtonTheme.Text}
      onClick={openSearch}
      aria-label="Search the documentation"
      className={classNames(classes.icon, className)}
    />
  );
};
